import * as S from "./style";

export interface TournamentRemoteControlProps {
  name: string;
  count: number;
  unit?: string;
  handleCount: (type: "minus" | "plus") => void;
  disabled?: boolean;
}

const TournamentRemoteControl = ({
  name,
  count,
  unit,
  handleCount,
  disabled,
}: TournamentRemoteControlProps) => {
  return (
    <S.EditTournamentRemoteControlWrapper>
      <div className="name">{name}</div>
      <S.EditTournamentRemoteControl>
        <div
          className="button"
          onClick={() => (disabled ? null : handleCount("minus"))}
        >
          <img src="/image-web/icon/minus.svg" alt="minus" />
        </div>
        <div className="count">
          {count} <span>{unit}</span>
        </div>
        <div
          className="button"
          onClick={() => (disabled ? null : handleCount("plus"))}
        >
          <img src="/image-web/icon/plus.svg" alt="plus" />
        </div>
      </S.EditTournamentRemoteControl>
    </S.EditTournamentRemoteControlWrapper>
  );
};

export default TournamentRemoteControl;
